import app from 'app';
import 'lib/modalService';
import 'style/chModal.scss';


/**
* Export the module's name so consumers can easily add it to their Angular
* module definition's dependencies.
*/
module.exports = app.name;



// WEBPACK FOOTER //
// ./index.js